






import { Component, Vue } from 'vue-property-decorator';
import * as firebase from 'firebase/app';

@Component
export default class Login extends Vue {
  async created() {
    await firebase.auth().signOut();

    this.$router.replace('/login');
  }
}
